import 'babel-polyfill';
import React from 'react';
import {ApolloProvider} from 'react-apollo';
import Navigation from './Navigation';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MUITheme from './theme.js';
import {ThemeProvider} from 'styled-components';
import moment from 'moment';
import client from './client';
moment.locale('de');

let theme = MUITheme.palette;
theme.menuColor = '#efefef';

export default () => (
  <ThemeProvider theme={theme}>
    <MuiThemeProvider muiTheme={MUITheme}>
      <ApolloProvider client={client}>
        <Navigation />
      </ApolloProvider>
    </MuiThemeProvider>
  </ThemeProvider>
);



// WEBPACK FOOTER //
// ./src/App.js